import React from "react";

export default class BCMSAsset {
    _assets; // Initalize a new map to store values

    // CONSTRUCTOR :: Map | [[*, *]] | { STRING: * } | VOID -> this
    constructor(values) {
        this.assets = values;
    }

    // add :: STRING, React.Component -> VOID
    // Add a new id, component values to the asset map
    add(id, component) {
        if(typeof id == "string"){
            this._assets.set(id, component);
            return this;
        }
        else {
            throw new Error("id property of an asset needs to be a STRING");
        }
    }

    // get :: STRING -> React.Component
    // Return a component by the id that is passed
    get(id) {
        return this._assets.get(id);
    }

    // img :: STRING, OBJECT -> React.Component
    // Return a new image tag with the src and passed properties set
    img(id, props) {
        return <img src={ this._assets.get(id) } { ...props } />
    }

    // svg :: STRING, OBJECT -> React.Component
    // Return an SVG with the properties set
    svg(id, props) {
        const SVG = this._assets.get(id);
        return <SVG { ...props } />
    }

    // loadAsset :: * -> OBJECT
    // Return an object that has the functions to retrieve an asset
    loadAsset() {
        return {
            "image" : (id, props) => this.img(id, props),
            "svg" : (id, props) => this.svg(id, props)
        };
    }

    // assets :: Map | [[*, *]] | { STRING: * } | VOID -> this
    // Setter for setting the _asset map property
    set assets(value) {
        if(value instanceof Array) {
            if(value.every(item => item instanceof Array)) {
                this._assets = new Map(value);
            }
            else {
                throw new Error("Passed value must be an ARRAY of ARRAYs");
            }
        }
        else if(value instanceof Map) {
            this._assets = value;
        }
        else if(value instanceof Object) {
            this._assets = new Map(Object.entries(value));
        }
        else {
            this._assets = new Map();
        }
    }

    // init :: * -> bcmsasset
    // Return a new BCMSAsset
    static init(values) {
        return new BCMSAsset(values);
    }
}